'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../../src/styles/external.scss');

require('../../src/styles/vars.scss');

var _reportModal = require('../../src/styles/report-modal.scss');

var _reportModal2 = _interopRequireDefault(_reportModal);

var _doctifyModal = require('./doctify-modal');

var _doctifyModal2 = _interopRequireDefault(_doctifyModal);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportModal = function (_React$Component) {
    (0, _inherits3.default)(ReportModal, _React$Component);

    function ReportModal() {
        (0, _classCallCheck3.default)(this, ReportModal);
        return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
    }

    ReportModal.prototype.isHasError = function isHasError() {
        return Boolean(!this.props.reportEmail || !this.props.reportText);
    };

    ReportModal.prototype.render = function render() {
        var _this2 = this;

        var props = this.props;
        var labelClasses = _reportModal2.default['label-block'] + (this.props.submitted && this.isHasError() ? ' ' + _reportModal2.default['label-block--err'] : '');

        if (this.props.accepted) {
            return _react2.default.createElement(
                _doctifyModal2.default,
                (0, _extends3.default)({}, props, {
                    className: props.className + ' ' + _reportModal2.default['modal--report'],
                    bodyStyles: _reportModal2.default.body,
                    header: _react2.default.createElement(
                        'span',
                        { className: _reportModal2.default.header },
                        'Thank You!'
                    ) }),
                _react2.default.createElement(
                    'div',
                    { className: _reportModal2.default['ok-text'] },
                    'Thank you for submitting your request. Someone on our team will review it within 48 hours.'
                ),
                _react2.default.createElement(
                    'div',
                    { className: _reportModal2.default['button-block'] },
                    _react2.default.createElement(
                        'button',
                        { className: 'btn solid ' + _reportModal2.default['ok-close'], onClick: props.closeModal },
                        'Close'
                    )
                )
            );
        }

        return _react2.default.createElement(
            _doctifyModal2.default,
            (0, _extends3.default)({}, props, {
                className: props.className + ' ' + _reportModal2.default['modal--report'],
                bodyStyles: _reportModal2.default.body,
                header: _react2.default.createElement(
                    'span',
                    { className: _reportModal2.default.header },
                    'Flag a Review as Inappropriate'
                ) }),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    { onSubmit: function onSubmit(event) {
                            event.preventDefault();
                            _this2.isHasError() ? props.invalidateReportModal() : props.sendReportModal(props.model);
                        } },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group ' + _reportModal2.default.formGroup },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'df-input-group ' + _reportModal2.default.inputContainer },
                                _react2.default.createElement('i', { className: 'ion-ios-email-outline' }),
                                _react2.default.createElement('input', { className: 'form-control ' + _reportModal2.default.formControl,
                                    placeholder: 'Email*',
                                    type: 'email',
                                    onChange: function onChange(event) {
                                        return props.changeReportModalEmail(event.target.value);
                                    },
                                    required: true
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group ' + _reportModal2.default.formGroup },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'df-input-group textarea' },
                                _react2.default.createElement('textarea', { className: 'form-control ' + _reportModal2.default.formControl,
                                    placeholder: 'Please describe why is this review inappropriate*',
                                    onChange: function onChange(event) {
                                        return props.changeReportModalText(event.target.value);
                                    },
                                    required: true
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: labelClasses },
                        '* indicates required field'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _reportModal2.default['button-block'] },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn solid' },
                            'SUBMIT'
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn specialist', onClick: function onClick(event) {
                                    event.preventDefault();
                                    props.closeModal();
                                } },
                            'CANCEL'
                        )
                    )
                )
            )
        );
    };

    return ReportModal;
}(_react2.default.Component);

;

ReportModal.displayName = 'ReportModal';

ReportModal.defaultProps = {
    className: ''
};

exports.default = ReportModal;


// WEBPACK FOOTER //
// ./components/doctify-modals/lib/components/report-modal.js